const lazyMetaGroupJoiner = ";";
const lazyMetaItemJoiner = ",";
const lazyMetaSubItemJoiner = ":";
const propertyFlagAttribute = 1 << 0;
const propertyFlagReflect = 1 << 1;
const propertyFlagBoolean = 1 << 2;
const propertyFlagNumber = 1 << 3;
const propertyFlagState = 1 << 4;
const propertyFlagReadOnly = 1 << 5;
const propertyFlagNoAccessor = 1 << 6;
export {
  lazyMetaGroupJoiner,
  lazyMetaItemJoiner,
  lazyMetaSubItemJoiner,
  propertyFlagAttribute,
  propertyFlagBoolean,
  propertyFlagNoAccessor,
  propertyFlagNumber,
  propertyFlagReadOnly,
  propertyFlagReflect,
  propertyFlagState
};
